"use strict";
angular.module("addUsersForRoleServiceModule", [
    "addUsersForRoleModule"
]).
factory("addUsersForRoleService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [addUserForRole description] 为角色添加用户
         * @param {[string]} [tagId,tagName] [description] 
         */
        addUsersForRole: function(roleId) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/roleManagement/userManagementForRole/service/addUsersForRole/addUsersForRole_tpl.html",
                windowClass: 'addUsersForRole',
                backdrop: false,
                controller: "addUsersForRoleCtrl",
                resolve: {
              		roleId:function(){
              			return roleId;
              		}
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },
    };
}]);